import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction, useProgressSuccess } from 'hooks';
import Account from 'modules/Account';
import CloudDrive from 'modules/CloudDrive';
// import { ExternalDataSources } from 'modules/DataSources';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import ImportPatientDatabaseModal from '../../ImportPatientDatabaseModal';
import ClinicCloudDrive from './ClinicCloudDrive';
import ImportPatientDatabase from './ImportPatientDatabase';
const AdminDataSettings = ()=>{
    // TODO: Move activeClinicMembership to ImportPatientDatabaseModal
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const isClinicAdmin = useSelector(Account.selectors.isClinicAdmin);
    if (!isClinicAdmin) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "row mb-11",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6 pr-10",
                children: /*#__PURE__*/ _jsx(ClinicCloudDrive, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6 pl-10",
                children: /*#__PURE__*/ _jsx(ImportPatientDatabase, {})
            }),
            /*#__PURE__*/ _jsx(ImportPatientDatabaseModal, {
                clinicMembership: activeClinicMembership
            })
        ]
    });
};
const DataSettings = ()=>{
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const authorizationCode = useSelector(CloudDrive.selectors.authorizationCode);
    const isInProgress = useSelector(selectors.isReauthorizeClinicCloudDriveInProgress);
    const hasErrors = useSelector(selectors.hasReauthorizeClinicCloudDriveError);
    const connectToClinic = useAction(Account.actions.connectToClinic, activeClinicMembership);
    const disconnectClinic = useAction(Account.actions.disconnectClinic);
    const reauthorizeClinicCloudDrive = useAction(actions.reauthorizeClinicCloudDrive);
    const onConnect = ()=>{
        disconnectClinic();
        if (activeClinicMembership.membershipStatus === 'Active') {
            connectToClinic();
        }
    };
    useEffect(()=>{
        if (authorizationCode) {
            reauthorizeClinicCloudDrive(authorizationCode, activeClinicMembership);
        } else {
            onConnect();
        }
    }, []);
    useProgressSuccess(isInProgress, hasErrors, onConnect);
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(AdminDataSettings, {})
    });
};
export default DataSettings;
